import http from '@/services/http';


export async function getSurvey(platform, surveyType) {
  try {
    const survey = await fetchSurveyType(platform, surveyType);

    return survey ? await fetchSurveyData(survey) : null;
  }
  catch (error) {
    throw error;
  }
}


export async function fetchSurveyData(form) {
  try {
    const { data } = await http.get(`/cardfree-api/v1/form/${form.id}`);

    return formatSurveyResponseData(data);
  }
  catch (error) {
    throw error;
  }
}


export async function fetchSurveyType(platform, surveyType) {
  try {
    const { data } = await http.get('/cardfree-api/v1/form', {
      params: {
        platform,
        surveyType
      }
    });

    return data.find(form => form.isActive);
  }
  catch (error) {
    throw error;
  }
}


export function formatSurveySubmissionRequest(surveyData, orderId = null) {
  const formattedAnswers = surveyData.questions.reduce((answers, question) => {
    const { id, answer } = question;

    if (Array.isArray(answer)) {
      answers.push(...answer.map(answerValue => ({ answer: answerValue, questionId: id })));
    }
    else {
      answers.push({ answer, questionId: id });
    }

    return answers;
  }, []);

  const formattedPayload = {
    answers: formattedAnswers,
    orderId
  };

  return formattedPayload;
}


export async function submitSurvey(surveyForm, orderId) {
  try {
    const requestBody = formatSurveySubmissionRequest(surveyForm, orderId);

    await http.post(`/cardfree-api/v1/form/${surveyForm.id}`, requestBody);
  }
  catch (error) {
    throw error;
  }
}


export function formatSurveyResponseData(surveyData) {
  const filterIsActive = x => x.isActive;

  const questions = surveyData.questions
    .filter(filterIsActive)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(question => ({
      ...question,
      answer: null,
      options: question.options.filter(filterIsActive)
    }));

  const formattedData = {
    ...surveyData,
    questions
  };

  return formattedData;
}


export default {
  getSurvey,
  fetchSurveyData,
  fetchSurveyType,
  submitSurvey,
  formatSurveySubmissionRequest,
  formatSurveyResponseData
};
